import { useQuery } from "@tanstack/react-query";
import { fetchData as fetchDataNode } from "../nodeApi/fetchData";
import { fetchData } from "./UseStudentGetApi";

export const useUserUnderManagerList = (filter) => {
    return useQuery({
        queryKey: ["users/reporting-to", filter],
        queryFn: () => fetchDataNode(`users/reporting-to`, filter),
    });
};

export const useMarketingManagerList = (filter) => {
    return useQuery({
        queryKey: ["getAllUsers/role", filter],
        queryFn: () => fetchDataNode(`getAllUsers/role`, filter),
    });
};